export default async function checkSnippets(message) {
  const pattern = /\{\{([a-zA-Z0-9_.]+)\}\}/g;
  const matches = message.match(pattern);
  if (!matches) return [];

  const cleanedMatches = matches.map((match) =>
    match.replace("{{", "").replace("}}", ""),
  );

  return cleanedMatches;
}
